import { ArrowDownRight, Code2, PenTool, Quote } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { projects } from '../../data/siteContent';
import { Reveal } from '../ui/Reveal';

// About frames the resume around Afshin's rare blend of engineering and leadership.
export function About() {
  const { t } = useApp();
  const stats = [
    { value: '10+', label: t.about.stat1 },
    { value: '03', label: t.about.stat2 },
    { value: String(projects.length).padStart(2, '0'), label: t.about.stat3 },
  ];

  return (
    <section id="about" className="about-section section-pad">
      <div className="page-shell about-grid">
        <Reveal className="about-heading">
          <p className="eyebrow">{t.about.kicker}</p>
          <h2 className="display-title">{t.about.title}</h2>
          <div className="about-monogram" aria-hidden="true"><span>A</span><span>Z</span></div>
        </Reveal>

        <div className="about-body">
          <Reveal><p className="about-lead">{t.about.body1}</p></Reveal>
          <Reveal delay={0.08}><p>{t.about.body2}</p></Reveal>
          <Reveal className="about-signature" delay={0.12}>
            <Quote size={22} />
            <strong>{t.about.signature}</strong>
            <ArrowDownRight size={25} />
          </Reveal>
        </div>

        <Reveal className="about-disciplines" delay={0.16}>
          <div><Code2 /><span>ENGINEERING</span><small>01</small></div>
          <div><PenTool /><span>DESIGN</span><small>02</small></div>
        </Reveal>
      </div>

      <div className="page-shell stats-grid">
        {stats.map((stat, index) => (
          <Reveal className="stat-card" delay={index * 0.08} key={stat.label}>
            <span className="stat-card__index">0{index + 1}</span>
            <strong>{stat.value}</strong>
            <p>{stat.label}</p>
          </Reveal>
        ))}
      </div>

      <div className="craft-ticker" aria-hidden="true">
        <div>
          {[...t.ticker, ...t.ticker].map((item, index) => (
            <span key={`${item}-${index}`}>{item}<i>✦</i></span>
          ))}
        </div>
      </div>
    </section>
  );
}
